import React from 'react';

const StopIcon = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "19",
    height: "20",
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style: { ...style, overflow: "visible" }
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M7.1276 3.66663H5.54427C5.12434 3.66663 4.72162 3.83344 4.42469 4.13037C4.12775 4.42731 3.96094 4.83003 3.96094 5.24996V14.75C3.96094 15.1699 4.12775 15.5726 4.42469 15.8695C4.72162 16.1665 5.12434 16.3333 5.54427 16.3333H7.1276C7.54753 16.3333 7.95026 16.1665 8.24719 15.8695C8.54412 15.5726 8.71094 15.1699 8.71094 14.75V5.24996C8.71094 4.83003 8.54412 4.42731 8.24719 4.13037C7.95026 3.83344 7.54753 3.66663 7.1276 3.66663Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.4609 3.66663H11.8776C11.4577 3.66663 11.055 3.83344 10.758 4.13037C10.4611 4.42731 10.2943 4.83003 10.2943 5.24996V14.75C10.2943 15.1699 10.4611 15.5726 10.758 15.8695C11.055 16.1665 11.4577 16.3333 11.8776 16.3333H13.4609C13.8809 16.3333 14.2836 16.1665 14.5805 15.8695C14.8775 15.5726 15.0443 15.1699 15.0443 14.75V5.24996C15.0443 4.83003 14.8775 4.42731 14.5805 4.13037C14.2836 3.83344 13.8809 3.66663 13.4609 3.66663Z",
      fill: "white"
    }
  )
);
StopIcon.displayName = "Icons.StopIcon";

export { StopIcon };
//# sourceMappingURL=StopIcon.js.map
